<template>
  <form id="frm_action">
    <div class="p-formgrid">
      <div class="col-6">
        <!-- License Plate Number -->
        <div class="p-card-field">
          <label class="p-col-fixed txt-right txt-required txt_style_lable"
          >Vehicle category</label
          >
          <div class="p-col">
            <v-select
                :disabled="!$commonFuction.isEmpty(obj_data.rental_order_id)"
                :key="key_vehicle_category"
                :clearable="false"
                class=""
                @search="SearchVehicleCategory"
                placeholder="Choose"
                v-model="obj_data.vehicle_category_id"
                :options="list_vehicle_category_id"
                :reduce="(item) => item.id"
                label="name"
                @input="change_list_vehicle_category"
            >
              <span slot="no-options" @click="$refs.select.open = false">
                Empty data
              </span>
            </v-select>
            <input
                class="input_tmp_validator"
                id="tmp_rent_vehicle_category_id"
            />
          </div>
        </div>

        <div class="p-card-field">
          <label class="p-col-fixed txt-right txt-required txt_style_lable"
          >License plate number</label
          >
          <div class="p-col">
            <!-- :disabled="core_disable('rent_vehicle_category_id')" -->
            <v-select
                    :disabled="!$commonFuction.isEmpty(obj_data.rental_order_id)"
                    :key="key_car_for_rent"
                    :clearable="false"
                    class=""
                    @search="SearchCarForRent"
                    placeholder="Choose"
                    v-model="obj_data.car_for_rent_id"
                    :options="list_car_for_rent_id"
                    :reduce="(item) => item.id"
                    label="license_plate_number"
                    @input="change_car_for_rent"
                >
                  <span slot="no-options" @click="$refs.select.open = false">
                    Empty data
                  </span>
                </v-select>
            <input
                class="input_tmp_validator"
                id="tmp_car_for_rent_id"
            />
          </div>
        </div>
        <div class="p-card-field">
          <label class="p-col-fixed txt-right txt-required txt_style_lable"
          >Renter</label
          >
          <div class="p-col">
            <v-select
                    :disabled="!$commonFuction.isEmpty(obj_data.rental_order_id)"
                :clearable="true"
                class=""
                @search="SearchUser"
                placeholder="Choose"
                v-model="obj_data.renter_id"
                :options="listUser"
                :reduce="(item) => item.id"
                label="name"
                @input="change_list_user"

            >
              <span slot="no-options" @click="$refs.select.open = false">
                Empty data
              </span>
            </v-select>
            <input class="input_tmp_validator" id="tmp_renter_id"/>
          </div>
        </div>

        <div class="p-card-field">
          <label class="class-bold1 p-col-fixed txt-right">Phone</label>
          <div class="p-col">
            <InputText disabled="disabled" v-model="obj_data.contact_phone"   />
          </div>
        </div>

         <div class="p-card-field">
          <label class="class-bold1 p-col-fixed txt-right">Rental Order ID</label>
          <div class="p-col">
            <InputText disabled="disabled" v-model="obj_data.code_order"   />
          </div>
        </div>

        <div class="p-card-field">
          <label class="class-bold1 p-col-fixed txt-right">RO Status</label>
          <div class="p-col">
            <InputText disabled="disabled" v-model="obj_data.booking_status"   />
          </div>
        </div>


        <!-- Valid Until -->
        <div class="p-card-field">
          <label class="class-bold1 p-col-fixed txt-right">Maintenance date</label>
          <div class="p-col">
            <Calendar id="maitenance_date" v-model="obj_data.maitenance_date" dateFormat="dd/mm/yy" :showIcon="true"   />
            <!-- <Calendar id="maintenance_date" v-model="obj_data.maitenance_date" dateFormat="dd/mm/yy" :showIcon="true"   /> -->
            <!-- <Calendar :showOnFocus="false" dateFormat="dd/mm/yy" :showIcon="true" appendTo="self" :showClear="true" :minDate="new Date()"
              :manualInput="false" v-model="obj_data.maintenance_date" placeholder="DD/MM/YYYY" id="maintenance_date" /> -->
          </div>
        </div>

        <!-- Color -->
        <div class="p-card-field">
          <label class="class-bold1 p-col-fixed txt-right">Notes</label>
          <div class="p-col">
            <Textarea id="note" maxLength="2000" rows="2" cols="30" :autoResize="true" class="ml-0"
              v-model="obj_data.note" placeholder="Input (max: 2,000 charactors)" @input="handleMaxCharacter('note', $event, 2000)" />
          </div>
        </div>

      </div>

      <!-- Buttons -->
      <Toolbar class="fixed-bottom-toolbar div-button">
        <template slot="right">
          <Button :label="$constants.TEXT_BUTTON.BACK" @click="backToList()" class="p-button-outlined" id="back" />
          <Button v-if="mode == 'edit'" id="edit" :label="$constants.TEXT_BUTTON.EDIT" @click="saveData()"
            class="main-style-button" />
          <Button v-else :label="$constants.TEXT_BUTTON.ADD" @click="saveData()" class="main-style-button" />
        </template>
      </Toolbar>
    </div>
  </form>
</template>

<script>
import moment from "moment-timezone";

export default {
  props: {
    mode: String,
    model: Object,
  },
  data() {
    return {
      showDeleteDialog: false,
      ListvehicleCategory: [],
      listRentalOrder: [],
      rentalOrder: [],
      obj_data: {
        active: true,
      },
      list_vehicle_category_id: [],
      list_vehicle_category_id_all: [],
      map_vehicle_category_id_all: {},
      key_vehicle_category: 0,
      key_car_for_rent: 0,
      list_car_for_rent_id: [],
      list_car_for_rent_id_all: [],
      map_car_for_rent_id_all: {},

      listUser: [],
      listUserAll: [],
      mapUserAll: {},

    };
  },
  async mounted() {
     this.getListUser();
    this.getListVehicleCategory();
    var list_status = this.$constants.LIST_STATUS_RENTAL_ORDER;
      var map_status = { }
      //$constants.CAR_FOR_RENT_STATUS
      for (const [key__1, value] of Object.entries(list_status)) {
        console.log("key__1",key__1)
        map_status[value.value] = value.label;
      }
    if (this.model && Object.keys(this.model).length > 0) {
      
      var obj_data = this.$commonFuction.convertJsonObject(this.model);
      // obj_data.vehicle_category_name = obj_data?.obj_rental_order_rent?.vehicle_category_name ?? '';
      // obj_data.license_plate_number = obj_data?.obj_rental_order_rent?.license_plate_number ?? '';
      console.log("obj_data?.obj_renter",obj_data?.obj_renter?.fullname)
      obj_data.contact_name = obj_data?.obj_renter?.fullname ?? '';
      obj_data.contact_phone = obj_data?.obj_renter?.phone ?? '';
      obj_data.code_order = obj_data?.obj_rental_order_rent?.obj_rental_order?.code ?? '';
      obj_data.booking_status = map_status[obj_data?.obj_rental_order_rent?.obj_rental_order?.booking_status];
    // console.log("obj_data1111",obj_data)
    // console.log("obj_data.maintenance_date")
    // console.log("obj_data.maintenance_date",obj_data.maitenance_date)
      
     this.obj_data = this.$commonFuction.convertJsonObject(obj_data);
     if (!this.$commonFuction.isEmpty(obj_data.maitenance_date)){
        this.obj_data.maitenance_date =new Date(obj_data.maitenance_date);
        console.log("obj_data.maintenance_date",obj_data.maitenance_date)
      }
      console.log("this.obj_data",this.obj_data)
      this.getListCarForRent();
    }
  },

  methods: {
    async change_list_user() {
      this.obj_data.contact_name = (this.mapUserAll[this.obj_data.renter_id]) ? this.mapUserAll[this.obj_data.renter_id].fullname : '';
      this.obj_data.contact_phone = (this.mapUserAll[this.obj_data.renter_id]) ? this.mapUserAll[this.obj_data.renter_id].phone : '';
    },
     async getListUser() {
      var where_key = {
        deleted: {_eq: false},
        role: {_eq: this.$constants.ROLE_ACCOUNT.USER},
        // booking: {id: {_is_null: true} },
      };
      var list = await this.$CoreService.getListUser(where_key);
      this.listUser = list.list;
      this.listUserAll = list.list;
      this.mapUserAll = list.list_map;
      console.log("this.mapUserAll",this.mapUserAll)
    },
    async SearchUser(search, loading) {
      console.log(loading);
      if (search !== "" && search !== null) {
        var where_key = {
          deleted: {_eq: false},
          role: {_eq: this.$constants.ROLE_ACCOUNT.USER},
        };
        if (!this.$commonFuction.isEmpty(search)) {
          where_key.fullname_email = {
            _iregex: this.$commonFuction.search(search),
          };
        }
        var list = await this.$CoreService.getListUser(where_key);
        this.listUser = list.list;
        //console.log("this.listProperty:",this.listProperty)
      } else {
        // cosnole.log("dasdasd")
        this.listUser = this.listUserAll;
      }
    },
    change_car_for_rent() {
      this.key_car_for_rent++;
      //this.generate_data();
    },
    //car_for_rent_id
    async getListCarForRent() {
      console.log("getListCarForRent")
      var where_key = {
        deleted: {_eq: false},
        // booking: {id: {_is_null: true} },
      };
      if (!this.$commonFuction.isEmpty(this.obj_data.vehicle_category_id)) {
        where_key["vehicle_category_id"] = {
          _eq: this.obj_data.vehicle_category_id,
        };
      }
      var list = await this.$CoreService.getListCarForRent(where_key);
      this.list_car_for_rent_id = list.list;
      this.list_car_for_rent_id_all = list.list;
      this.map_car_for_rent_id_all = list.map_list;
    },
    async SearchCarForRent(search, loading) {
      console.log(loading);
      if (search !== "" && search !== null) {
        var where_key = {
          deleted: {_eq: false},
        };
        if (this.obj_data.is_allow_car_category != true) {
          where_key["vehicle_category_id"] = {
            _eq: this.obj_data.rent_vehicle_category_id,
          };
        }
        if (!this.$commonFuction.isEmpty(search)) {
          where_key.license_plate_number = {
            _iregex: this.$commonFuction.search(search),
          };
        }
        var list = await this.$CoreService.getListCarForRent(where_key);
        this.list_car_for_rent_id = list.list;
        //console.log("this.listProperty:",this.listProperty)
      } else {
        // cosnole.log("dasdasd")
        this.list_car_for_rent_id = this.list_car_for_rent_id_all;
      }
    },
    async change_list_vehicle_category() {
      this.obj_data.car_for_rent_id = null;
      await this.getListCarForRent();
      this.key_car_for_rent_event++;
    },
    async getListVehicleCategory() {
      var where_key = {
        deleted: {_eq: false},
        // booking: {id: {_is_null: true} },
      };
      // if (!this.$commonFuction.isEmpty(rent_car_for_rent_id)){
      //   where_key["rent_car_for_rent_id"] =  {_eq : rent_car_for_rent_id}
      // }
      var list = await this.$CoreService.getLisVehicleCategory(where_key);
      this.list_vehicle_category_id = list.list;
      this.list_vehicle_category_id_all = list.list;
      this.map_vehicle_category_id_all = list.map_list;
    },
    async SearchVehicleCategory(search, loading) {

      console.log("SearchVehicleCategory");
      console.log(loading);
      if (search !== "" && search !== null) {
        var where_key = {
          deleted: {_eq: false},
        };
        // if (!this.$commonFuction.isEmpty(this.model.rent_car_for_rent_id)){
        //   where_key["rent_car_for_rent_id"] =  {_eq : this.model.rent_car_for_rent_id}
        // }
        if (!this.$commonFuction.isEmpty(search)) {
          where_key.name = {
            _iregex: this.$commonFuction.search(search),
          };
        }
        var list = await this.$CoreService.getLisVehicleCategory(where_key);
        this.list_vehicle_category_id = list.list;
        //console.log("this.listProperty:",this.listProperty)
      } else {
        // cosnole.log("dasdasd")
        this.list_vehicle_category_id = this.list_vehicle_category_id_all;
      }
    },
    core_disable(input_name = "") {
      // console.log("sasasawqwqfdf")
      var is_return = false;
      //dùng switch case để xử lý các trường hợp disable
      // console.log("this.mode:", this.mode);
      if (this.mode == "view") {
        return true;
      }
      switch (input_name) {
        case "booking_status":
          if (this.mode == "edit") {
            is_return = true;
          }
          break;
        case "color_car_forent":
          is_return = true;
          break;
        case "created_at":
          is_return = true;
          break;
        case "post_id":
          is_return = true;
          break;
        case "rent_available_id":
          is_return = false;
          break;
        case "rent_vehicle_category_id":
          is_return = false;
          break;
        case "rent_term_id":
          is_return = false;
          break;
        case "rent_pick_up_date":
          is_return = false;
          break;
        case "rent_valid_until":
          is_return = false;
          break;
        case "showroom_id":
          is_return = false;
          break;
        case "contract_id":
          is_return = false;
          break;
        case "note":
          is_return = false;
          break;
        case "uid":
          is_return = false;
          break;
        case "rent_contact_name":
          is_return = false;
          break;
        case "rent_contact_phone":
          is_return = false;
          break;
        case "rent_contact_email":
          is_return = false;
          break;
        case "rent_identification_information":
          is_return = false;
          break;
        case "rent_number_id":
          is_return = false;
          break;
        case "rent_pay_price_per_week":
          is_return = false;
          break;
        case "rent_pay_bond_fee":
          is_return = false;
          break;
        case "rent_late_fee_threshold":
          is_return = false;
          break;
        case "rent_late_fee_per_day":
          is_return = false;
          break;
        case "rent_booking_fee":
          if (this.mode == "edit") {
            is_return = true;
          }
          break;
        case "rent_voucher_id":
          is_return = false;
          break;
        case "is_pay_booking_fee":
          is_return = false;
          break;
        default:
      }
      // console.log("is_return:"+input_name,is_return)
      return is_return;
    },
    handleMaxCharacter(field, event, maxLength = 255) {
      let value = event
      if (value.length > maxLength) {
        value = value.slice(0, maxLength)
      }
      this.obj_data[field] = value; 
    },
    formatDate(dateString) {
      if (!dateString) return null;
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); 
      const year = date.getFullYear();
  
      return `${day}/${month}/${year}`;
    },
    async getLisVehicleCategory() {
      try {
        var where_key = { deleted: { _eq: false } };
        var list = await this.$CoreService.getLisVehicleCategory(where_key);
        if (list && list.list) {
          this.ListvehicleCategory = list.list;
        } else {
          console.log('No data returned');
        }

      } catch (error) {
        console.error('Error loading vehicle categories:', error);
      }
    },
    async getLisRentalOrder() {
      try {
        var where_key = { deleted: { _eq: false } };
        var list = await this.$CoreService.getLisRentalOrder(where_key);
        if (list && list.list) {
          this.listRentalOrder = list.list.map(order => ({
            id: order.id,
            code: order.code
          }));
        }
      } catch (error) {
        console.error('Error loading rental orders:', error);
      }
    },

    backToList() {
      this.$emit('back');
    },
    async validateData() {
      this.validationErrors = {};
      //validate các field required vd vehicle category
      let tmp_rent_vehicle_category_id = document.getElementById(
          "tmp_rent_vehicle_category_id"
      );
      if (this.$commonFuction.isEmpty(this.obj_data.vehicle_category_id)) {
        tmp_rent_vehicle_category_id.setCustomValidity(
            this.$constants.MSG_TEXT.SELECT_INVALID_MSG
        );
      } else {
        tmp_rent_vehicle_category_id.setCustomValidity("");
      }

      var tmp_renter_id = document.getElementById("tmp_renter_id");
      if (this.$commonFuction.isEmpty(this.obj_data.renter_id)) {
        tmp_renter_id.setCustomValidity(this.$constants.MSG_TEXT.SELECT_INVALID_MSG);
      } else {
        tmp_renter_id.setCustomValidity("");
      }


      var tmp_car_for_rent_id = document.getElementById("tmp_car_for_rent_id");
      if (this.$commonFuction.isEmpty(this.obj_data.car_for_rent_id)) {
        tmp_car_for_rent_id.setCustomValidity(this.$constants.MSG_TEXT.SELECT_INVALID_MSG);
      } else {
        tmp_car_for_rent_id.setCustomValidity("");
      }

      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()) {
        console.log("test=====================");
        inpObj.reportValidity();
        return true;
      }
    },

    async saveData() {
      this.$commonFuction.is_loading(true);

      // Kiểm tra validate
      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return; // Dừng nếu có lỗi
      }
      var  params = this.obj_data;
      if (params.maintenance_date instanceof Date) {
        // Nếu valid_until là đối tượng Date, định dạng lại
        params.maintenance_date = moment(params.maintenance_date).format('YYYY-MM-DD');
      } else if (typeof params.maintenance_date === 'string') {
        // Nếu valid_until là chuỗi "dd/MM/yyyy", chuyển thành định dạng YYYY-MM-DD
        const regoDate = moment(params.maintenance_date, 'DD/MM/YYYY');
        params.maintenance_date = regoDate.isValid() ? regoDate.format('YYYY-MM-DD') : null;
      }

      console.log("this.mapUserAll",this.mapUserAll)
      var renter_id =  this.obj_data?.renter_id ?? null;
      var info_renter = this.mapUserAll?.[renter_id] ?? null;
      this.obj_data.info_renter = info_renter;
      console.log("this.obj_datathis.obj_data",this.obj_data)
    
      this.$emit('save', this.obj_data);
    }


    ,
  },
};

</script>
<style lang="scss">
.p-multiselect {
  width: 450px;
}

.p-multiselect-label:not(.p-placeholder) {
  padding-top: .25rem;
  padding-bottom: .25rem;
}

.category-item-value {
  padding: .25rem .5rem;
  border-radius: 3px;
  display: inline-flex;
  margin-right: .2rem;
  background-color: var(--primary-color);
  color: var(--primary-color-text);
}

.p-multiselect-label-container {
  height: 40px;
}

.p-inputtext {
  margin: 0px 0px 0px 4px;
}

@media screen and (min-width: 1001px) {
  .input_distance {
    width: 728px !important;
  }
}

div.p-card-field {
  padding: 0px !important;
}

.p-col-fixed {
  padding: 0px !important;
  margin: 0px 0px 0px 9px !important;
}

.input_text {
  width: 760px !important;
  height: 48px !important;
}


.multiselect {
  width: 760px !important;
}



.vs__clear {
  display: none;
}

.input_width {
  width: 760px !important;
  height: 48px !important;
}

#distance {
  width: 1px !important;
  height: 48px !important;
  border-left: 0px;
  border-top: 0px;
  border: 1px solid #C8C8C8;
  border-radius: 0px;
}

.manager-title {
  font-size: 24px !important;
}

.input-dif {
  margin-left: 5px !important;
  border-top: 0px;
}

.p-inputgroup-addon {
  height: 48px;
}

.p-col-fixed {
  padding: 0px !important;
}

div.p-card-field {
  padding: 0px !important;
}

.margin {
  margin-bottom: 12px !important;
}

.border_color {
  border: 1px solid #C8C8C8;
}

.text {
  font-weight: normal !important;
  margin-left: 15px !important;
}

.div_check {
  margin-top: 12px !important;
}

//responsive
@media screen and (max-width: 600px) {
  .input_width {
    width: 100% !important;
  }

  .div-button {
    padding: 8px !important;
  }

  #distance {
    text-align: left !important;
    padding: 6.8px;
    width: 100% !important;
  }

  .p-inputgroup-addon {
    margin-right: 12px;
  }
}

@media screen and (max-width: 1000px) {
  .input_width {
    width: 100% !important;
  }

  .div-button {
    padding: 8px !important;
  }

  .p-inputgroup-addon {
    margin-right: 12px;
  }

  #distance {
    text-align: left !important;
    padding: 6.8px;
  }
}

.p-button-outlined {
  .p-button-label {
    color: #FFDF01 !important;
  }
}

.service--product .vs__dropdown-toggle {
  height: 48px;
}

.class-bold1 {
  font-weight: bold;
}



.p-button-outlined .p-button-label {
    color: #000000 !important;
}
</style>
